import React from 'react';
import { Pricing } from '../swagger';
import { api } from '../utils/api';

export const usePricings = (shouldFetch: boolean, deps: any[] = []) => {
  const [pricings, setPricings] = React.useState<Pricing[]>([]);

  const loadPricings = React.useCallback(async () => {
    setPricings(await api.adminControllerGetPricings());
  }, []);

  React.useEffect(() => {
    if (shouldFetch) {
      loadPricings().catch((e) => console.error(e));
    } else if (pricings.length) {
      setPricings([]);
    }
    // `deps` is this hook's public API -- callers pass what should retrigger a
    // load -- so the array is deliberately dynamic and cannot be checked
    // statically. loadPricings is rebuilt each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetch, ...deps]);

  return [pricings, setPricings, loadPricings] as const;
};
